import React, { ReactFragment } from "react"

interface CareerSearchFitlerTypes {
  children: ReactFragment
}

const CareerSearchFitler = ({ children }: CareerSearchFitlerTypes) => (

  <div className="grid__col grid__col--1-4 grid__col--md-1-1">
    <div className="grid grid--gutters-xsm">
      {children}
    </div>
  </div>

)

export default CareerSearchFitler